/* Kerzen Pfeilstetter — theme.js
   Bewusst minimal & progressiv. Schwere Logik vermeiden (Performance = SEO). */
(function () {
  'use strict';

  // Mobile-Navigation umschalten
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.toggleAttribute('hidden');
  });

  // Mengen-Stepper (Produktseite): −/+ aktualisieren das quantity-Feld
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = e.target.closest('[data-qty-wrapper]');
    if (!wrap) return;
    var input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var val = parseInt(input.value, 10) || min;
    input.value = plus ? val + 1 : Math.max(min, val - 1);
  });

  // Farb-Swatches (Produktseite): aktive Farbe in der scrollbaren Leiste zentrieren.
  // Nur horizontaler Scroll der Leiste selbst — die Seite bewegt sich nicht.
  function centerActiveSwatches(root) {
    var strips = (root || document).querySelectorAll('[data-color-swatches]');
    Array.prototype.forEach.call(strips, function (strip) {
      var container = strip.querySelector('.color-swatches__grid');
      var active = strip.querySelector('.color-swatch.is-active');
      if (!container || !active) return;
      var cRect = container.getBoundingClientRect();
      var aRect = active.getBoundingClientRect();
      // Horizontale Leiste (Mobile, eine Zeile): aktive Farbe etwa zentrieren.
      if (container.scrollWidth > container.clientWidth + 1) {
        var delta = (aRect.left - cRect.left) - (container.clientWidth - active.clientWidth) / 2;
        // Eine Position weiter links als die Mitte: um genau einen Swatch-Schritt
        // weiter scrollen (aus dem Abstand zum vorherigen Swatch abgeleitet).
        var step = active.clientWidth + 8;
        var prev = active.previousElementSibling;
        if (prev) step = aRect.left - prev.getBoundingClientRect().left;
        container.scrollLeft += delta + step;
      }
      // Mehrzeiliges Raster mit begrenzter Höhe (Desktop): aktive Farbe vertikal
      // in Sicht holen, falls sie unterhalb der Kappung liegt.
      if (container.scrollHeight > container.clientHeight + 1) {
        var vDelta = (aRect.top - cRect.top) - (container.clientHeight - active.clientHeight) / 2;
        container.scrollTop += vDelta;
      }
    });
  }

  // Scroll-Fades: blendet die Rand-Verläufe ein, je nachdem ob noch mehr Inhalt
  // scrollbar ist — macht Scrollbarkeit sichtbar. Horizontal (Mobile-Leiste):
  // has-start/has-end. Vertikal (Desktop-Raster mit Höhenkappung): has-top/
  // has-bottom (Blur an der Unterkante, „es geht weiter").
  function updateScrollFade(grid) {
    var scroller = grid.closest('[data-scroll-fade]');
    if (!scroller) return;
    var maxX = grid.scrollWidth - grid.clientWidth;
    scroller.classList.toggle('has-start', grid.scrollLeft > 2);
    scroller.classList.toggle('has-end', grid.scrollLeft < maxX - 2);
    var maxY = grid.scrollHeight - grid.clientHeight;
    scroller.classList.toggle('has-top', grid.scrollTop > 2);
    scroller.classList.toggle('has-bottom', grid.scrollTop < maxY - 2);
  }
  // Scroll-Listener je Grid binden. Idempotent über data-fade-ready, damit nach
  // einem Section-Austausch (Stufe 2) nur neue Grids gebunden werden.
  function initScrollFades(root) {
    var grids = (root || document).querySelectorAll('[data-scroll-fade] .color-swatches__grid');
    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.dataset.fadeReady) return;
      grid.dataset.fadeReady = '1';
      updateScrollFade(grid);
      grid.addEventListener('scroll', function () { updateScrollFade(grid); }, { passive: true });
    });
  }
  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-scroll-fade] .color-swatches__grid'), updateScrollFade);
  });

  // Stufe 2: Farbwechsel ohne sichtbaren Reload über die Section Rendering API
  // (gleiches Prinzip wie der Cart-Drawer). Jeder Swatch bleibt ein echter
  // <a href> — ohne JS, bei Modifier-Klick oder bei einem Fehler übernimmt die
  // normale Navigation (Progressive Enhancement).
  function updateDocTitle(name) {
    if (!name) return;
    // Tab-Titel ist „<Seite> – <Shop>". Nur die <Seite> durch die neue Farbe
    // ersetzen, den Shop-Teil (letztes Segment) behalten. Trenner: – — |.
    var parts = document.title.split(/\s[–—|]\s/);
    var shop = parts.length > 1 ? parts[parts.length - 1] : '';
    document.title = shop ? name + ' – ' + shop : name;
  }

  // Den main-product-Bereich per fetch durch die Zielfarbe ersetzen und neu
  // initialisieren. Gibt ein Promise auf das Section-Element zurück.
  function swapProductSection(section, url) {
    var sectionId = section.id.replace('shopify-section-', '');
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(sectionId);
    // WICHTIG: KEIN 'Accept: application/json' senden. Bei einer /products/-URL
    // behandelt Shopify das wie /products/handle.json und liefert die Produkt-
    // Ressource ({"product": …}) — der ?sections=-Parameter wird dann ignoriert
    // und data[sectionId] ist null. Das JSON-Format steuert allein ?sections=.
    return fetch(fetchUrl)
      .then(function (r) { if (!r.ok) throw new Error('swatch fetch failed'); return r.json(); })
      .then(function (data) {
        var html = data && data[sectionId];
        if (html == null) throw new Error('section missing');
        // Die Section Rendering API liefert die Section INKLUSIVE ihres
        // <div id="shopify-section-…">-Wrappers. Nur dessen Inhalt übernehmen,
        // sonst verschachtelt sich bei jedem Wechsel ein weiterer Wrapper mit
        // doppelter id.
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById(section.id);
        // Den eigentlichen DOM-Tausch kapseln, damit er entweder direkt oder
        // innerhalb einer View Transition (sanfter Crossfade) laufen kann. Den
        // Lade-Zustand HIER entfernen, damit der „Nachher"-Snapshot der View
        // Transition den Bereich nicht gedimmt zeigt.
        function applySwap() {
          section.classList.remove('is-swatch-loading');
          // Scroll-Position der Farbleiste(n) merken — der innerHTML-Tausch baut
          // sie neu auf (Scroll 0), wir wollen sie aber stehen lassen. Mobile
          // scrollt horizontal (scrollLeft), Desktop vertikal (scrollTop).
          var prevScroll = [];
          Array.prototype.forEach.call(section.querySelectorAll('.color-swatches__grid'), function (g) {
            prevScroll.push({ left: g.scrollLeft, top: g.scrollTop });
          });
          section.innerHTML = fresh ? fresh.innerHTML : html;
          // Position VOR dem Init wiederherstellen, damit die Scroll-Fades direkt
          // korrekt berechnet werden.
          Array.prototype.forEach.call(section.querySelectorAll('.color-swatches__grid'), function (g, i) {
            if (prevScroll[i]) { g.scrollLeft = prevScroll[i].left; g.scrollTop = prevScroll[i].top; }
          });
          // isSwap=true → nicht neu zentrieren (kein Springen). Ein Fehler beim
          // Neu-Initialisieren darf NICHT zum Vollreload führen — Inhalt steht schon.
          try { initProductSection(section, true); } catch (err) {}
        }
        // Sanfter Übergang per View Transitions API, wo verfügbar und vom Nutzer
        // gewünscht (prefers-reduced-motion). Sonst harter Tausch wie bisher.
        var smooth = document.startViewTransition &&
          !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        if (smooth) {
          return document.startViewTransition(applySwap).updateCallbackDone
            .then(function () { return section; }, function () { return section; });
        }
        applySwap();
        return section;
      });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('a.color-swatch');
    if (!sw) return;
    // Modifier-/Mittelklick (neuer Tab/Fenster) und fehlende APIs dem Browser überlassen.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var section = sw.closest('[id^="shopify-section-"]');
    if (!section || !('fetch' in window) || !window.history || !history.pushState) return;
    e.preventDefault();
    if (section.classList.contains('is-swatch-loading')) return;
    var targetUrl = sw.href;
    section.classList.add('is-swatch-loading');
    swapProductSection(section, targetUrl)
      .then(function (sec) {
        // pushState auf die echte Produkt-URL → Canonical/URL bleiben korrekt.
        history.pushState({ kpProduct: true }, '', targetUrl);
        var title = sec.querySelector('.product__title');
        updateDocTitle(title && title.textContent.trim());
        // Fokus auf die nun aktive Farbe (preventScroll: kein Sprung).
        var active = sec.querySelector('.color-swatch.is-active');
        if (active && active.focus) {
          active.setAttribute('tabindex', '-1');
          try { active.focus({ preventScroll: true }); } catch (err) { active.focus(); }
        }
        section.classList.remove('is-swatch-loading');
      })
      .catch(function () {
        // Fallback: harte Navigation (Zielseite scrollt zum Produkt).
        try { sessionStorage.setItem('kp-color-switch', '1'); } catch (err) {}
        window.location.href = targetUrl;
      });
  });

  // Zurück/Vor im Verlauf: reload-freie Wechsel sind eigene History-Einträge im
  // selben Dokument → den Produktbereich auf die jetzige URL zurückrendern.
  window.addEventListener('popstate', function () {
    var swatches = document.querySelector('[data-color-swatches]');
    if (!swatches) return;
    var section = swatches.closest('[id^="shopify-section-"]');
    if (!section || section.classList.contains('is-swatch-loading')) return;
    section.classList.add('is-swatch-loading');
    swapProductSection(section, window.location.pathname)
      .then(function (sec) {
        var title = sec.querySelector('.product__title');
        updateDocTitle(title && title.textContent.trim());
        section.classList.remove('is-swatch-loading');
      })
      .catch(function () { window.location.reload(); });
  });

  function scrollToProduct() {
    var product = document.querySelector('.product');
    if (!product) return;
    var header = document.querySelector('.site-header');
    var headerH = header ? header.getBoundingClientRect().height : 0;
    var top = product.getBoundingClientRect().top + window.pageYOffset - headerH;
    window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
  }

  try {
    if (sessionStorage.getItem('kp-color-switch')) {
      sessionStorage.removeItem('kp-color-switch');
      scrollToProduct();
    }
  } catch (err) {}

  // Bildergalerie (Produktseite): horizontaler Slider. Die Hauptbilder liegen als
  // Slides nebeneinander in einer Spur (.product__media-track); Chevrons,
  // Thumbnail-Klick und Wischen verschieben die Spur smooth per translateX.
  // Beim Wischen folgt die Spur dem Finger und schnappt beim Loslassen um.
  // Thumbnails teilen die Reihenfolge der Slides (1:1 nach Index).
  function initProductSlider(root) {
    var slider = (root || document).querySelector('[data-media-slider]');
    if (!slider) return;
    if (slider.dataset.sliderReady) return;
    slider.dataset.sliderReady = '1';
    var track = slider.querySelector('[data-media-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-media-slide]')) : [];
    if (!track || slides.length < 2) return;

    var gallery = document.querySelector('[data-product-gallery]');
    var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]')) : [];

    var index = 0;
    for (var s = 0; s < slides.length; s++) {
      if (slides[s].classList.contains('is-active')) { index = s; break; }
    }

    function scrollThumbIntoView(thumb) {
      var c = thumb && thumb.parentElement;
      if (!c) return;
      var cR = c.getBoundingClientRect(), tR = thumb.getBoundingClientRect();
      if (tR.left < cR.left) c.scrollLeft -= (cR.left - tR.left) + 8;
      else if (tR.right > cR.right) c.scrollLeft += (tR.right - cR.right) + 8;
    }

    // Spur an den aktuellen Index setzen. animate === false → ohne Übergang
    // (für die Startposition und das Mitlaufen während des Wischens).
    function render(animate) {
      track.classList.toggle('is-grabbing', animate === false);
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === index);
      }
      for (var j = 0; j < thumbs.length; j++) {
        thumbs[j].classList.toggle('is-active', j === index);
      }
      if (thumbs[index]) scrollThumbIntoView(thumbs[index]);
    }

    function goTo(i, animate) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      render(animate);
    }

    // Chevrons
    slider.addEventListener('click', function (e) {
      if (e.target.closest('[data-gallery-prev]')) { goTo(index - 1, true); return; }
      if (e.target.closest('[data-gallery-next]')) { goTo(index + 1, true); return; }
    });
    // Thumbnail-Klick → passenden Slide anschieben
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (!thumb) return;
        var t = thumbs.indexOf(thumb);
        if (t > -1) goTo(t, true);
      });
    }

    // Wischen: die Spur folgt dem Finger, beim Loslassen wird umgeblättert bzw.
    // zurückgeschnappt. touch-action:pan-y (CSS) überlässt uns die horizontale
    // Geste, vertikales Scrollen bleibt beim Browser.
    var startX = 0, startY = 0, dx = 0, width = 0, dragging = false, active = false;

    slider.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { active = false; return; }
      active = true; dragging = false; dx = 0;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      width = slider.clientWidth || 1;
    }, { passive: true });

    slider.addEventListener('touchmove', function (e) {
      if (!active) return;
      dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (!dragging) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(dx) < Math.abs(dy)) { active = false; return; } // vertikal → Seite scrollt
        dragging = true;
        track.classList.add('is-grabbing');
      }
      var offset = dx;
      // Randwiderstand am ersten/letzten Bild
      if ((index === 0 && dx > 0) || (index === slides.length - 1 && dx < 0)) offset = dx * 0.35;
      track.style.transform = 'translateX(' + (-index * width + offset) + 'px)';
    }, { passive: true });

    function endDrag() {
      if (!active) return;
      active = false;
      if (!dragging) { track.classList.remove('is-grabbing'); return; }
      dragging = false;
      // Schon ~18 % der Breite genügen zum Umblättern.
      if (Math.abs(dx) > width * 0.18) goTo(index + (dx < 0 ? 1 : -1), true);
      else render(true);
    }
    slider.addEventListener('touchend', endDrag, { passive: true });
    slider.addEventListener('touchcancel', endDrag, { passive: true });

    // Startposition ohne Übergang setzen, danach Transitions wieder erlauben.
    render(false);
    requestAnimationFrame(function () { track.classList.remove('is-grabbing'); });
  }

  // Variantenauswahl (Button-Gruppe): Preis auf die gewählte Variante aktualisieren.
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('input[name="id"][type="radio"]');
    if (!radio) return;
    var price = radio.getAttribute('data-price');
    if (!price) return;
    var priceEls = document.querySelectorAll('[data-product-price]');
    Array.prototype.forEach.call(priceEls, function (el) { el.textContent = price; });
  });

  // Such-Overlay mit Predictive Search (progressive Enhancement: ohne JS führt
  // das Such-Icon weiterhin auf die /search-Seite).
  (function initSearch() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    var form = modal.querySelector('form[data-predictive-url]');
    var input = modal.querySelector('[data-search-input]');
    var results = modal.querySelector('[data-predictive-results]');
    var endpoint = form ? form.getAttribute('data-predictive-url') : '/search/suggest';
    var lastFocus = null, controller = null, debounce = null;

    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      modal.removeAttribute('hidden');
      document.documentElement.classList.add('search-open');
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        if (input) input.focus();
      });
    }
    function close() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('search-open');
      modal.setAttribute('hidden', '');
      if (controller) controller.abort();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) { open(e); return; }
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    function fetchResults(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      results.setAttribute('data-loading', '');
      var url = endpoint + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          results.removeAttribute('data-loading');
          results.innerHTML = html;
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') results.removeAttribute('data-loading');
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounce);
        if (q.length < 2) {
          if (controller) controller.abort();
          results.innerHTML = '';
          return;
        }
        debounce = setTimeout(function () { fetchResults(q); }, 220);
      });
    }
  })();

  // Produktkarten-Vorschau-Galerie.
  // Mobil: native Wischgeste (Scroll-Snap, kein JS nötig). Desktop: bei Hover
  // automatisch zum 2. Bild + Pfeile; Punkt-Indikator folgt der Scroll-Position.
  var cardHover = window.matchMedia ? window.matchMedia('(hover: hover)') : { matches: false };

  // Aktueller Index = Slide, dessen echte Position (offsetLeft) der Scroll-
  // Position am nächsten liegt. Robust gegen Sub-Pixel-Rundung.
  function cardCurrentIndex(gallery) {
    var children = gallery.children;
    var sl = gallery.scrollLeft;
    var best = 0, bestDist = Infinity;
    for (var i = 0; i < children.length; i++) {
      var dist = Math.abs(children[i].offsetLeft - sl);
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    return best;
  }
  function cardGoTo(gallery, index) {
    var children = gallery.children;
    var idx = Math.max(0, Math.min(children.length - 1, index));
    var target = children[idx];
    // Auf die EXAKTE Slide-Position scrollen (nicht auf eine gerechnete Breite),
    // damit der Snap-Punkt pixelgenau getroffen wird und kein Nachbarbild durchblitzt.
    if (target) gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
  }
  function cardSyncDots(card, gallery) {
    var dots = card.querySelectorAll('[data-card-dot]');
    if (!dots.length) return;
    var idx = cardCurrentIndex(gallery);
    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.classList.toggle('is-active', i === idx);
    });
  }

  function initCardGalleries(root) {
    var galleries = (root || document).querySelectorAll('[data-card-gallery]');
    Array.prototype.forEach.call(galleries, function (gallery) {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = '1';
      var card = gallery.closest('[data-product-card]');
      if (!card || gallery.children.length < 2) return;
      var media = card.querySelector('.product-card__media');

      var raf = 0;
      gallery.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; cardSyncDots(card, gallery); });
      });

      // Desktop: Hover zeigt das 2. Bild (Hinweis, dass es mehr Bilder gibt).
      if (cardHover.matches && media) {
        media.addEventListener('mouseenter', function () { cardGoTo(gallery, 1); });
        media.addEventListener('mouseleave', function () { cardGoTo(gallery, 0); });
      }
    });
  }

  // Pfeile (Desktop): navigieren, ohne dem umgebenden Produktlink zu folgen.
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-card-prev], [data-card-next]');
    if (!nav) return;
    e.preventDefault();
    var card = nav.closest('[data-product-card]');
    var gallery = card && card.querySelector('[data-card-gallery]');
    if (!gallery) return;
    var dir = nav.hasAttribute('data-card-next') ? 1 : -1;
    cardGoTo(gallery, cardCurrentIndex(gallery) + dir);
  });

  // Produktseite: Swatches zentrieren, Scroll-Fades und Bild-Slider aufsetzen.
  // Idempotent — nach einem Section-Austausch (Stufe 2) erneut aufrufbar.
  // isSwap=true beim reload-freien Farbwechsel: dann NICHT neu zentrieren, damit
  // die Farbleiste nicht springt (der Aufrufer stellt die Scroll-Position wieder
  // her). Nur beim ersten Seitenaufruf die aktive Farbe in den Blick holen.
  function initProductSection(root, isSwap) {
    if (!isSwap) centerActiveSwatches(root);
    initScrollFades(root);
    initProductSlider(root);
  }

  initProductSection(document);
  initCardGalleries();

  // Theme-Editor: Sections beim Wiederladen nicht doppelt initialisieren
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initProductSection(e.target);
      initCardGalleries(e.target);
    });
  }
})();
